import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/challengerConversionSaga";

const OffersFitter = () => {
  const dispatch = useDispatch();

  const { filters, selectedFilters } = useSelector((state) => state.challengerConversion);

  const onSelectChange = (data) => dispatch(actionCreators.updateFilters(data));

  return (
    <MultiSelectDropdown
      options={filters}
      selectedFilters={selectedFilters}
      placeholder="Select Offers"
      enableOnly
      numberDisplayed={0}
      maxSelect={6}
      enableMax
      avoidSelectIfMaxSelected
      onSelectChange={onSelectChange}
    />
  );
};

export default OffersFitter;
